<template>
  <div class="Stripe--diagonal-box" :style="componentStyle">
    <v-container class="Stripe__content">
      <slot />
    </v-container>
    <div class="Stripe--border Stripe--border-long"></div>
    <div class="Stripe--border Stripe--border-short"></div>
  </div>
</template>

<script>
export default {
  name: "Stripe",

  props: {
    componentStyle: {
      type: String,
      default: "background-color: #c4c4c4",
    },
  },
};
</script>

<style>
.Stripe--diagonal-box {
  transform: skewY(-8deg);
  padding: 125px 0;
}

.Stripe__content {
  /* max-width: 80%; */
  margin: 0 auto;
  transform: skewY(8deg);
}

.Stripe--border {
  height: 40px;
  float: right;
  opacity: 0.7;
}

.Stripe--border-long {
  margin-top: 125px;
  width: 30vw;
  background: #80e9ff;
}

.Stripe--border-short {
  margin-top: 150px;
  margin-right: -20vw;
  width: 15vw;
  background: #7a73ff;
}
</style>
